import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollSmoother } from 'gsap/ScrollSmoother.js';
import { SplitText } from 'gsap/SplitText.js';

/** Componsante SCroller de TimTools */
export default class Scroller {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
    this.element = element;
    this.scroller;
    this.hasSkew = false;
    this.debug = false;

    this.setOptions();
    document.fonts.ready.then(this.init.bind(this));
  }
  setOptions() {
    if (this.element.querySelector('.js-horiz')) {
      this.initHorizSections();
    }

    if ('pinItems' in this.element.dataset) {
      this.initPins();
    }
    if ('debug' in this.element.dataset) {
      this.debug = true;
    }
  }

  init() {
    this.scroller = ScrollSmoother.create({
      smooth: 2,
      effects: true,
      smoothTouch: 0.1,
      ease: 'expo.out',
    });

    this.initOnScrollAnim();
  }
  initOnScrollAnim() {
    const anims = this.element.querySelectorAll('[data-scroller-anim]');
    for (let i = 0; i < anims.length; i++) {
      const anim = anims[i];
      console.log(anim.dataset.scrollerAnim);
      switch (anim.dataset.scrollerAnim) {
        case 'horizLines':
          this.initHorizLinesAnim(anim);
          break;
        case 'rotate':
          this.initRotateAnim(anim);
          break;
        default:
          console.error('You need to specify an animType');
          break;
      }
    }
  }

  initHorizLinesAnim(animElement) {
    const splittedEl = SplitText.create(animElement, {
      type: 'lines',
      autoSplit: true,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        scrub: 1,
        trigger: animElement.parentElement,
        start: 'center 40%',
        end: 'bottom top',
        markers: this.debug,
      },
    });
    splittedEl.lines.forEach((line, i) => {
      const x = i % 2 == 0 ? 200 : -200;
      tl.to(
        line,
        {
          x: x,
        },
        0
      );
    });
  }
  initRotateAnim(animElement) {
    const tl = gsap.timeline({
      scrollTrigger: {
        scrub: 1,
        trigger: animElement.dataset.parent,
        start: 'top 100%',
        end: 'bottom top',
        markers: this.debug,
      },
    });
    tl.to(
      animElement,
      {
        rotate: 100,
      },
      0
    );
  }
  initPins() {
    this.pinnedItems = this.element.querySelectorAll('.js-pinned');
    for (let i = 0; i < this.pinnedItems.length; i++) {
      const element = this.pinnedItems[i];

      ScrollTrigger.create({
        pin: element,
        trigger: element.parentElement,
        start: 'center center',
        end: '80% center',
      });
    }
  }
  initHorizSections() {
    // TODO faire boucle pour plusieurs
    const buffer = 200;
    const sectionHoriz = this.element.querySelector('.js-horiz');

    const pannels = sectionHoriz.querySelectorAll('.js-panel');
    const nbPannels = pannels.length - 1;

    gsap.to(pannels, {
      xPercent: -100 * nbPannels,
      ease: 'none',
      scrollTrigger: {
        trigger: sectionHoriz,
        pin: true,
        scrub: 1,
        snap: 1 / nbPannels,
        end: () => '+=' + (sectionHoriz.offsetWidth + buffer),
      },
    });
  }
}
